var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch, Model } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import RegexStr from "../../common/RegexStr";
import ImgCropper from './ImgCropper.vue';
var PhotoUpload = (function (_super) {
    __extends(PhotoUpload, _super);
    function PhotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogImageUrl = '';
        _this.dialogVisible = false;
        _this.pdfDialogUrl = '';
        _this.pdfDialogVisible = false;
        _this.pdfRegx = new RegExp(RegexStr.pdf);
        return _this;
    }
    PhotoUpload.prototype.fileListWatch = function () {
        this.handlePlusIconShow();
    };
    PhotoUpload.prototype.mounted = function () {
        this.handlePlusIconShow();
    };
    PhotoUpload.prototype.handleCrop = function (url, oldUrl) {
        var fileList = cloneDeep(this.fileList);
        var index = fileList.findIndex(function (v) { return v.url == oldUrl; });
        if (index > -1) {
            fileList[index].url = url;
            this.$emit("change", fileList);
        }
    };
    PhotoUpload.prototype.handleEdit = function (file) {
        console.log('handleEdit>>>', file);
        this.$refs.imgCropper.show(file.url);
    };
    PhotoUpload.prototype.handlePlusIconShow = function () {
        if (this.$refs.upload) {
            var currentLength = this.fileList.length;
            var displayStatus = currentLength >= this.limit ? "none" : "";
            this.$refs.upload.$children[1].$el.style.display = displayStatus;
        }
    };
    PhotoUpload.prototype.handleRemove = function (file) {
        var _this = this;
        var CALL_BACK = function () {
            var fileList = _this.fileList.filter(function (v) { return v.url != file.url; });
            _this.$emit("change", JSON.parse(JSON.stringify(fileList)));
        };
        if (this.removeConfirmTip) {
            this.$confirm(this.removeConfirmTip).then(function () {
                CALL_BACK();
            }).catch(function () { });
            return;
        }
        CALL_BACK();
    };
    PhotoUpload.prototype.handlePictureCardPreview = function (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    };
    PhotoUpload.prototype.handlePdfPreview = function (file) {
        this.pdfDialogUrl = file.url;
        this.pdfDialogVisible = true;
    };
    PhotoUpload.prototype.exceedLimit = function (files, fileList) {
        this.$message({
            showClose: true,
            message: "最多上传" + this.limit + "张",
            type: 'error'
        });
    };
    PhotoUpload.prototype.beforeAvatarUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "jpeg" || fileType == 'jpg' || fileType == "gif" || fileType == "png" || fileType == "pdf"))) {
            this.$message.error("上传文件不符合格式，只能jpeg、jpg、gif、png、pdf格式");
            return false;
        }
        ;
        var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单张图片不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
    };
    PhotoUpload.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            var fileName = file.name || '文件';
            this.$message({
                showClose: true,
                message: fileName + " \u4E0A\u4F20\u5B8C\u6210\uFF01",
                type: 'success'
            });
            if (fileList.length) {
                var imageList = fileList;
                imageList.forEach(function (item) { return item.response && (item.url = item.response.data.full_path); });
                this.$emit("change", imageList);
            }
        }
        else {
            this.$message({
                showClose: true,
                message: response.msg || "上传失败",
                type: 'error'
            });
        }
    };
    PhotoUpload.prototype.uploadError = function (err, file, fileList) {
        this.$message({
            showClose: true,
            message: err.msg || err.message || "上传失败",
            type: 'error'
        });
    };
    __decorate([
        Prop({
            default: "/supplierapi/upload",
            type: String
        })
    ], PhotoUpload.prototype, "action", void 0);
    __decorate([
        Prop({
            default: true,
            type: Boolean
        })
    ], PhotoUpload.prototype, "multiple", void 0);
    __decorate([
        Prop({
            default: 5,
            type: Number
        })
    ], PhotoUpload.prototype, "limit", void 0);
    __decorate([
        Prop({
            default: 10,
            type: Number
        })
    ], PhotoUpload.prototype, "maxSize", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], PhotoUpload.prototype, "removeConfirmTip", void 0);
    __decorate([
        Model("change", {
            required: true,
            type: Array,
        })
    ], PhotoUpload.prototype, "fileList", void 0);
    __decorate([
        Watch("fileList")
    ], PhotoUpload.prototype, "fileListWatch", null);
    PhotoUpload = __decorate([
        Component({
            components: {
                ImgCropper: ImgCropper
            }
        })
    ], PhotoUpload);
    return PhotoUpload;
}(Vue));
export default PhotoUpload;
